export const isSuccessStatusCode = (statusCode: string | number) => {
    return `${statusCode}`.startsWith('20');
};

export function appendQueryParam(endpoint: string, key: string, value: string): string {
    const url = new URL(endpoint, 'http://dummy-base');
    url.searchParams.append(key, value);
    return url.pathname + url.search;
}
